// AssignPackageDialog.js
import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import { getApi, postApi } from 'views/services/api';
import { useState } from 'react';
import { toast } from 'react-toastify';

const AssignPackageDialog = ({ open, handleClose, hotelName, selectedHotel, setSelectedHotel, packageData }) => {
  const [successfulPayments, setSuccessfulPayments] = useState(null);
  const handleAssignClick = async () => {
    console.log('Package assigned to hotel:', packageData);

    const responses = await getApi(`api/payments/list/?createdBy=${selectedHotel}`);
    if (responses && responses.status === 200) {
      setSuccessfulPayments(responses?.data?.paymentsData);

      console.log(successfulPayments)
    }
    const isAlreadyPurchased = successfulPayments?.some((payment) => payment.status === 'active' || payment.status === 'expiresSoon');
    if (isAlreadyPurchased) {
      toast.error('Cannot Assign Plan, You Already have Assigned or Purchased One');
    } else {
      const paymentPayload = {
        amount: packageData?.amount,
        createdBy: selectedHotel,
        days: packageData?.days,
        description: packageData?.description,
        subscription_id: packageData?._id,
        title: packageData?.title,
        isAdmin : true , 
      };
      let response = await postApi('api/payments/add', paymentPayload);
      console.log('paymentPayload============>>>>', paymentPayload);
    }

    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>Assign Package</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <InputLabel id="hotel-select-label">Select Hotel</InputLabel>
          <Select
            labelId="hotel-select-label"
            id="hotel-select"
            value={selectedHotel}
            label="Select Hotel"
            onChange={(e) => setSelectedHotel(e.target.value)}
          >
            {hotelName?.map((hotel) => (
              <MenuItem key={hotel?._id} value={hotel?._id}>
                {hotel?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleAssignClick} variant="contained">
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignPackageDialog;
